import { FC } from 'react';
import classnames from 'classnames';
import { LayOutPageLeftProps, LayOutPageItemEnum } from './interface';

const LayOutPageLeft: FC<LayOutPageLeftProps> = props => {
  const { children, className, ...restProps } = props;
  const classes = classnames('yb-layout-page-left', className);
  return (
    <div className={classes} {...restProps}>
      {children}
    </div>
  );
};

LayOutPageLeft.displayName = LayOutPageItemEnum.Left;

export default LayOutPageLeft;
